import React, { useCallback, useRef } from 'react'
import { ScrollableElementContext } from '../../contextApi'
import AiImageReferenceImages from './ReferenceImages'
import AiImageGenerationModel from './Model'
import AiImageGenerationAspectRatio from './AspectRatio'
import AiImageStyles from './ImageStyles'
import AiImageGenerationPrompt from './Prompt'
import * as Styled from './styled'
import GeneratedImage from './GeneratedImage'
import { useDispatch, useSelector } from 'react-redux'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import { aiImageThunks } from 'store/features/aiImage/thunks'
// import { ResetFormButton } from 'components/ResetFormButton'
// import { dispatch } from 'store'
// import { aiImageThunks } from 'store/features/aiImage/thunks'

const AiImageGenerateTabContent: React.FC = () => {
  const scrollableElementRef = useRef<HTMLDivElement | null>(null)
  const allStyles = useSelector(aiImageSelectors.styles)

  // const handleGenerateNew = () => {
  //   dispatch(aiImageThunks.resetGenerateForm())
  // }
  const dispatch = useDispatch()
  const styleId = useSelector(aiImageSelectors.styleId)
  const onSetStyleId = useCallback(
    (selectedStyleId: number | string | undefined) => {
      dispatch(aiImageThunks.setStyleId(selectedStyleId as number))
    },
    [dispatch]
  )

  return (
    <ScrollableElementContext.Provider
      value={{
        scrollableElementRef
      }}
    >
      <Styled.AiImageGenerateTabContent ref={scrollableElementRef}>
        {/* <ResetFormButton onClick={handleGenerateNew} /> */}
        <AiImageGenerationModel />
        <GeneratedImage />
        <AiImageGenerationPrompt />
        <AiImageReferenceImages />
        <Styled.OptionsRow>
          <AiImageGenerationAspectRatio />
          <AiImageStyles
            styleId={styleId}
            onSetStyleId={onSetStyleId}
            styles={allStyles}
          />
        </Styled.OptionsRow>
      </Styled.AiImageGenerateTabContent>
    </ScrollableElementContext.Provider>
  )
}

export default AiImageGenerateTabContent
